import { AlertCircle, CheckCircle, Clock } from "lucide-react";

export default function Warningpage ({testData, handleStartTest}) {

    return (
        <>
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
        <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto overflow-x-hidden shadow-2xl">
          <div className="relative p-8 text-white bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800">
            <div className="absolute top-0 right-0 w-64 h-64 -mt-32 -mr-32 bg-white rounded-full opacity-5"></div>
            <div className="relative">
              <h2 className="mb-2 text-3xl font-bold">Test Instructions</h2>
              <p className="text-xl text-blue-100">{testData.test_name}</p>
            </div>
          </div>
          
          <div className="p-8 space-y-6">
            <div className="p-6 border-l-4 rounded-lg bg-amber-50 border-amber-500">
              <h3 className="flex items-center mb-4 text-xl font-bold text-gray-800">
                <AlertCircle className="mr-2" size={24} />
                Important Information
              </h3>
              <div className="grid grid-cols-2 gap-4 text-gray-700">
                <div className="flex items-center">
                  <Clock className="mr-2 text-amber-600" size={20} />
                  <span><strong>Duration:</strong> {testData.duration} minutes</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="mr-2 text-amber-600" size={20} />
                  <span><strong>Questions:</strong> {testData.questions?.length || 0}</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-xl text-green-600">+</span>
                  <span><strong>Correct:</strong> +{testData.marks_per_question} marks</span>
                </div>
                {testData.negative_marking && (
                  <div className="flex items-center">
                    <span className="mr-2 text-xl text-red-600">−</span>
                    <span><strong>Wrong:</strong> {testData.negative_marks} mark</span>
                  </div>
                )}
              </div>
            </div>

            <div className="p-6 border-l-4 border-blue-500 rounded-lg bg-blue-50">
              <h3 className="mb-4 text-lg font-bold text-gray-800">Instructions</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 mr-3 text-sm font-bold text-white bg-blue-500 rounded-full flex items-center justify-center mt-0.5">1</span>
                  <span>Timer starts immediately after clicking "Start Test"</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 mr-3 text-sm font-bold text-white bg-blue-500 rounded-full flex items-center justify-center mt-0.5">2</span>
                  <span>Navigate freely between questions using question palette</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 mr-3 text-sm font-bold text-white bg-blue-500 rounded-full flex items-center justify-center mt-0.5">3</span>
                  <span>Mark questions for review if you want to revisit them later</span>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-6 h-6 mr-3 text-sm font-bold text-white bg-blue-500 rounded-full flex items-center justify-center mt-0.5">4</span>
                  <span>Submit before time expires or test will auto-submit</span>
                </li>
              </ul>
            </div>

            <div className="p-6 border-l-4 border-red-500 rounded-lg bg-red-50">
              <h3 className="mb-3 text-lg font-bold text-gray-800">Important Guidelines</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <span className="mr-2 text-red-500">⚠</span>
                  Do not refresh or close the browser during test
                </li>
                <li className="flex items-center">
                  <span className="mr-2 text-red-500">⚠</span>
                  Ensure stable internet connection throughout
                </li>
                <li className="flex items-center">
                  <span className="mr-2 text-red-500">⚠</span>
                  Keep your device charged or connected to power
                </li>
              </ul>
            </div>

            <div className="flex gap-4 pt-4">
              <button onClick={() => window.history.back()}
                className="flex-1 px-6 py-4 font-semibold text-gray-700 transition-all duration-200 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400"
              >
                Go Back
              </button>
              <button onClick={handleStartTest}
                className="flex-1 px-6 py-4 font-bold text-white transition-all duration-200 transform shadow-lg bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl hover:from-blue-700 hover:to-indigo-700 "
              >
                Start Test
              </button>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}